module.exports = __webpack_public_path__ + "a474b83f5f4ee8aaa90d6b40183ff98a.svg";